<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/T91H94/tc-custom/9780226351841.jpg?1731788337811" alt="This image is the cover for the book War Ledger"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">War Ledger
      </h1>
      <p class="bookDescription body article font2">
        <i>The War Ledger</i> provides fresh, sophisticated answers to fundamental questions about major modern wars: Why do major wars begin? What accounts for victory or defeat in war? How do victory and defeat influence the recovery of the combatants? Are the rules governing conflict behavior between nations the same since the advent of the nuclear era?<br/><br/> The authors find such well-known theories as the balance of power and collective security systems inadequate to explain how conflict erupts in the international system. Their rigorous empirical analysis proves that the power-transition theory, hinging on economic, social, and political growth, is more accurate; it is the differential rate of growth of the two most powerful nations in the system—the dominant nation and the challenger—that destabilizes all members and precipitates world wars.<br/><br/> Predictions of who will win or lose a war, the authors find, depend not only on the power potential of a nation but on the capability of its political systems to mobilize its resources—the "political capacity indicator." After examining the aftermath of major conflicts, the authors identify national growth as the determining factor in a nation's recovery. With victory, national capabilities may increase or decrease; with defeat, losses can be enormous. Unexpectedly, however, in less than two decades, losers make up for their losses and <i>all</i> combatants find themselves where they would have been had no war occurred.<br/><br/> Finally, the authors address the question of nuclear arsenals. They find that these arsenals do not make the difference that is usually assumed. Nuclear weapons have not changed the structure of power on which international politics rests. Nor does the behavior of participants in nuclear confrontation meet the expectations set out in deterrence theory.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        A.F.K. Organski, Jacek Kugler
      </h2>
      
      <p class="authorDescription body article"><B>A. F. K. Organski</B> is professor of political science at the University of Michigan. <B>Jacek Kugler</B> is professor of political science at Vanderbilt University. They are the coauthors, with J. Timothy Johnson and Youssef Cohen, of <I>Births, Deaths, and Taxes: The Demographic and Political Transitions</I>, also published by the University of Chicago Press.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The University of Chicago Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?3fa67ef4